export const fontFamilies = [
    {key: "Arial", text: "Arial", value: "Arial"},
    {key: "Calibri", text: "Calibri", value: "Calibri"},
    {key: "Helvetica", text: "Helvetica", value: "Helvetica"},
    {key: "Times New Roman", text: "Times New Roman", value: "Times New Roman"},
    {key: "Courier New", text: "Courier New", value: "Courier New"},
    {key: "Verdana", text: "Verdana", value: "Verdana"},
    {key: "Georgia", text: "Georgia", value: "Georgia"},
    {key: "Comic Sans MS", text: "Comic Sans MS", value: "Comic Sans MS"},
    {key: "Impact", text: "Impact", value: "Impact"},
    {key: "Arial Black", text: "Arial Black", value: "Arial Black"},
    {key: "Arial Narrow", text: "Arial Narrow", value: "Arial Narrow"},
]